import React, {useState, useEffect, useRef} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, Button, DatePicker, Pagination, Tag} from "antd";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";
import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import AuthService from "../login/AuthService";
import SelectPlantonistaModal from "./SelectPlantonistaModal";
import moment from "moment";
import "moment/locale/pt-br";
import locale from "antd/es/date-picker/locale/pt_BR"; // Importando o locale do antd
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
// import './assets/css/Duty.css';
import dayjs from 'dayjs';
import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import ImportModal from "../import/ImportModal";
import CustomPagination from "../util/CustomPagination";
import UsersSearch from "../dashboard/calender/UsersSearch";
import ScalePostingSelectedModal from "../scale/ScalePostingSelectedModal";
import DutyMigrateUserModal from "./DutyMigrateUserModal";
import LoadingScreen from "../util/LoadingScreen";
import PlantaoPersonalModal from "../dashboard/calender/plantaoPersonalModal";
import DutyPresenceCheckModal from "./modal/DutyPresenceCheckModal";

const {RangePicker} = DatePicker;


moment.locale('pt-br');

const PresenceCheckPage = () => {
    document.title = "Verificação Biométrica | Plantão Rápido";
    const refUserSearch = useRef(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [showSelectedModal, setShowSelectedModal] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [arrayDutySelected, setArrayDutySelected] = useState(null);


    const user = AuthService.getUserData();


    const validedManager = (types = [], checkManager = false) => {
        const selectedCompany = user?.companies?.find(c => c.selected === 1) || user?.companies?.[0];
        return selectedCompany?.managers?.length > 0;

    };

    const checkManager = validedManager();

    const oneMonthFromNow = moment().add(1, 'month');
    const [showImportModal, setShowImportModal] = useState(false);
    const [docTypeModalData, setDocTypeModalData] = useState(null);
    const [users, setUsers] = useState(AuthService.getUserData());
    const [duties, setDuties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalPersonalVisible, setModalPersonalVisible] = useState(false);
    const [selectPlantonistaVisible, setSelectPlantonistaVisible] = useState(false);
    const [selectedDuty, setSelectedDuty] = useState(null);
    const today = dayjs();
    const endOfNextMonth = dayjs().add(1, 'month').endOf('month');

    const [filters, setFilters] = useState({
        dateRange: [today, endOfNextMonth],
        datestart: today.format("YYYY-MM-DD"),
        dateend: endOfNextMonth.format("YYYY-MM-DD"),
        status: "",
        hospital: "",
        invalid: false
    });
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});


    const handleSearchFiltersChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };


    const fetchAll = async (page = 1, isExport = false, pdf = false) => {
        if (!isExport) {
            setLoading(true);
        }

        try {
            let firstDay = null;
            let lastDay = null;

            if (isExport) {
                setLoadingPage(true);
            }

            // Define o responseType baseado no tipo de exportação
            const responseType = isExport ? 'blob' : 'json';
            console.log(responseType);

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}presence/history`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    invalid_filter: filters.invalidFilter,
                    hospital_id: filters.hospital,
                    datestart: filters?.datestart,
                    dateend: filters?.dateend,
                    isExport: isExport,
                    user_id: filters.user_id,
                    ...(user.users_type_id === 1 && {logged_in_user: true}),
                },
                true,
                responseType
            );

            if (isExport || pdf) {

                // Determina o tipo de arquivo com base no pdf flag
                const fileType = pdf
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                const fileExtension = pdf ? 'pdf' : 'xlsx';

                // Cria o blob do arquivo
                const blob = new Blob([response], {type: fileType});
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `duties_export_presence_check_${new Date().toISOString().split('T')[0]}.${fileExtension}`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                // Se não for exportação, trata a resposta JSON normalmente
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setDuties(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        setFilters((prev) => {
            // Apenas define se não houver datas ainda
            if (!prev.datestart && !prev.dateend) {
                return {
                    ...prev,
                    dateRange: [today, endOfNextMonth],
                    datestart: today.format("YYYY-MM-DD"),
                    dateend: endOfNextMonth.format("YYYY-MM-DD"),
                };
            }
            return prev;
        });

        fetchAll(1, false, false);
    }, []);


    const handleModalOpen = (duty = null) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };


    const handleModalClose = (save = false) => {
        setModalVisible(false);
        setSelectedDuty(null);
        if (save) {
            fetchAll(pagination.current, false, false); // Refresh the list after modal is closed
        }
    };


    const handleFilterChange = (changedFilters) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ...changedFilters,
        }));
    };


    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            datestart: null,
            dateend: null,
            status: "",
            hospital: "",
            invalid: false,
        });
    };

    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            // Somente atualiza o filtro se o hospital tiver um ID válido
            handleFilterChange({hospital: hospital.value});
        } else {
            // Se nenhum hospital for selecionado (hospital é null), limpe o filtro
            handleFilterChange({hospital: null});
        }
    };


    const calculateDuration = (start, end) => {
        if (!start || !end) return "00:00:00";
        const s = new Date(start);
        const e = new Date(end);
        const diffMs = e - s;
        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };


    const handleCheckboxChange = (id) => {
        setSelectedIds((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((itemId) => itemId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };


    const invalidFilterOptions = [
        {
            options: [
                {value: "no_check", label: "Sem check-in/check-out"},
                {value: "less", label: "Carga Realizada Menor"},
                {value: "more", label: "Carga Realizada Maior"},
            ],
        },
    ];


    const timeToMinutes = (timeStr) => {
        if (!timeStr) return 0;
        const [h, m, s] = timeStr.split(":").map(Number);
        return h * 60 + m + (s >= 30 ? 1 : 0); // arredonda se s >= 30
    };

    const minutesToTime = (minutes) => {
        const sign = minutes < 0 ? "-" : "";
        const abs = Math.abs(minutes);
        const h = Math.floor(abs / 60);
        const m = abs % 60;
        return `${sign}${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
    };

    const calculateMinutes = (start, end) => {
        if (!start || !end) return 0;
        const s = new Date(start);
        const e = new Date(end);
        return Math.floor((e - s) / 60000); // em minutos
    };



    return (
        <React.Fragment>
            {loadingPage && <LoadingScreen/>}
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Verificação Biométrica" pageTitle="Plantão"/>
                    <Row className="g-4 mb-4">
                        <div className="col-sm-12">
                            <div className="row mt-4 mb-4">
                                <div className="col-md-4">
                                    <div className="form-group ">
                                        <label>Data</label>
                                        <div className="form-control">
                                            <RangePicker
                                                style={{border: "none", boxShadow: "none"}}
                                                locale={locale}
                                                format="DD/MM/YYYY"
                                                className="range-picker-custom"
                                                value={filters.dateRange.length > 0 ? filters.dateRange : null}
                                                onChange={(dates) => {
                                                    if (dates) {
                                                        handleSearchFiltersChange("dateRange", dates);
                                                        handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                        handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                    } else {
                                                        handleSearchFiltersChange("dateRange", []);
                                                        handleSearchFiltersChange("datestart", null);
                                                        handleSearchFiltersChange("dateend", null);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <HospitalSearch
                                        buttonAdd={false}
                                        cache={false}
                                        all={user?.users_type_id === 1}
                                        validateManager={true}
                                        onHospitalSelect={onHospitalSelect}
                                    />
                                </div>
                                {(checkManager || user?.users_type_id === 2) && (
                                    <div className="col-md-4 form-group">
                                        <UsersSearch
                                            ref={refUserSearch}
                                            onUserSelect={(user) =>
                                                setFilters((prevFilters) => ({
                                                    ...prevFilters,
                                                    user_id: user?.value || "",
                                                }))
                                            }
                                        />
                                    </div>
                                )}
                                <div className="col-md-4 form-group">

                                    <label>Inconsistência</label>

                                    <Select
                                        value={filters.invalidFilter}
                                        onChange={(selectedOption) => {
                                            setFilters(prev => ({
                                                ...prev,
                                                invalidFilter: selectedOption
                                            }));
                                        }}
                                        options={invalidFilterOptions}
                                        name="invalidFilter"
                                        placeholder="Selecione..."
                                        id="invalidFilter"
                                    />
                                </div>
                            </div>
                            <div className="row mt-4 mb-3">
                                <div className="col-md-12 d-flex justify-content-end">
                                    <button type="button" className="btn  mr-1  me-2"
                                            onClick={() => handleClearFilters()}>
                                        <i className="fa fa-eraser"></i> Limpar Filtros
                                    </button>
                                    <button type="button" className="btn btn-dark btn-s mr-1 me-2"
                                            onClick={() => fetchAll(1, true, false)}>
                                        <i className="fas fa-file-excel"></i> Exportar
                                    </button>
                                    <button type="button"
                                            className="btn btn-success"
                                            onClick={() => fetchAll(1, false, false)}
                                            disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Buscando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-search me-2"></i> Buscar
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>

                            <Row className="gy-2 mb-2" id="candidate-list">
                                {loading ? (
                                    <>
                                        <div className="card duty-card shadow-sm mb-3">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-3">
                                                        <Skeleton width={150} height={150}/>
                                                    </div>
                                                    <div className="col-9">
                                                        <Skeleton width={200}/>
                                                        <p>
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    duties.length > 0 ? (
                                        duties.map((duty) => (
                                            <Col lg={12} key={duty.id}>
                                                <Card className="mb-2 p-1 shadow-sm card-hover duty-card">
                                                    <CardBody className="p-2">
                                                        <Row className="align-items-center">
                                                            {/* Coluna 1 - Checkbox */}
                                                            <Col xs={1} className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="checkbox-wrapper-23"
                                                                    checked={selectedIds.includes(duty.id)}
                                                                    onChange={() => handleCheckboxChange(duty.id)}
                                                                    style={{width: "16px", height: "16px"}}
                                                                />
                                                            </Col>

                                                            {/* Coluna 2 - Usuário + plantão */}
                                                            <Col xs={6} md={4}>
                                                                {duty.accept_user && (
                                                                    <div className="d-flex  mb-2">
                                                                        {duty.user_id !== user?.id && (
                                                                            <Avatar
                                                                                src={duty.accept_user.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                                size={40}
                                                                                style={{
                                                                                    width: 40,
                                                                                    height: 40,
                                                                                    borderRadius: "50%",
                                                                                    objectFit: "cover",
                                                                                    marginRight: 8,
                                                                                }}
                                                                            />
                                                                        )}
                                                                        <div>
                                                                            <strong className="d-block">
                                                                                {duty.id_user_accepted === user?.id ? "Meu Plantão" : duty.accept_user.name}
                                                                            </strong>
                                                                            <p className="mb-1">
                                                                                <i className="fa fa-tag me-1 text-info"></i>
                                                                                {duty.id}
                                                                            </p>

                                                                            <small className="text-muted">
                                                                                <i className="fa fa-map-marker-alt me-1 text-info"></i>
                                                                                {duty.hospital?.city?.name}, {duty.hospital?.uf}
                                                                            </small>
                                                                            <p className="mb-1">
                                                                                <i className="fa fa-building text-info me-1"></i>
                                                                                {duty.department?.name || "Departamento não informado"}
                                                                            </p>

                                                                            <div>
                                                                                {duty.specialties?.map((s) => (
                                                                                    <Tag key={s.id} color="blue"
                                                                                         style={{fontSize: "0.75rem"}}>
                                                                                        {s.name}
                                                                                    </Tag>
                                                                                ))}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                )}

                                                            </Col>

                                                            {/* Coluna 3 - Datas e valor */}
                                                            <Col xs={6} md={3}>
                                                                <p className="text-muted mb-1">
                                                                    <i className="fa fa-calendar text-info me-1"></i>
                                                                    {new Date(duty.date_time).toLocaleDateString("pt-BR")}{" "}
                                                                    {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </p>
                                                                <p className="text-muted mb-2">
                                                                    <i className="fa fa-calendar text-info me-1"></i>
                                                                    {new Date(duty.date_time_end).toLocaleDateString("pt-BR")}{" "}
                                                                    {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </p>
                                                                <p className="text-success fw-bold mb-0">
                                                                    {new Intl.NumberFormat("pt-BR", {
                                                                        style: "currency",
                                                                        currency: "BRL",
                                                                    }).format(duty.value)}
                                                                </p>
                                                            </Col>

                                                            {/* Coluna 4 - Hospital */}
                                                            <Col xs={12} md={2} className="text-center">
                                                                <div
                                                                    className="d-flex flex-column align-items-center ml-2">
                                                                    <Avatar
                                                                        src={
                                                                            duty.hospital?.images?.[0]?.file ||
                                                                            `${process.env.REACT_APP_URL_STORAGE}src/hospital_icone.png`
                                                                        }
                                                                        size={40}
                                                                        style={{
                                                                            width: 40,
                                                                            height: 40,
                                                                            borderRadius: "50%",
                                                                            objectFit: "cover",
                                                                            backgroundColor: "#f0f0f0",
                                                                            marginBottom: 4,
                                                                        }}
                                                                    />
                                                                    <strong
                                                                        className="text-center"
                                                                        style={{fontSize: "11px", lineHeight: "1.1"}}
                                                                    >
                                                                        {duty.hospital?.name?.split(" ").slice(0, 4).join(" ")}
                                                                    </strong>
                                                                    <small className="text-muted"
                                                                           style={{fontSize: "10px"}}>
                                                                        {duty.hospital?.name?.split(" ").slice(4).join(" ")}
                                                                    </small>
                                                                </div>
                                                            </Col>

                                                            {/* Coluna 5 - Botões de ação */}
                                                            <Col xs={12} md={2}
                                                                 className="">


                                                                <>
                                                                    {/* Duração planejada */}
                                                                    <p className="mb-1">
                                                                        <i className="fa fa-clock text-info me-1"></i>
                                                                        Duração: {calculateDuration(duty.date_time, duty.date_time_end)}
                                                                    </p>

                                                                    {/* Carga horária trabalhada */}
                                                                    <p className="mb-1">
                                                                        <i className="fa fa-check-circle text-success me-1"></i>
                                                                        Trabalhada: {duty.total_worked_hours || "-"}
                                                                    </p>

                                                                    {/* Intervalo */}
                                                                    <p className="mb-1">
                                                                        <i className="fa fa-coffee text-warning me-1"></i>
                                                                        Intervalo: {duty.lunch_time ? `${duty.lunch_time} min` : "-"}
                                                                    </p>

                                                                    {/* Saldo */}
                                                                    <p className="mb-1">
                                                                        <i className="fa fa-balance-scale text-primary me-1"></i>
                                                                        Saldo: {
                                                                        (() => {
                                                                            const plannedMinutes = calculateMinutes(duty.date_time, duty.date_time_end);
                                                                            const lunch = Number(duty.lunch_time) || 0;
                                                                            const worked = timeToMinutes(duty.total_worked_hours);
                                                                            const saldo = worked - (plannedMinutes - lunch);

                                                                            const saldoStr = minutesToTime(saldo);
                                                                            const saldoClass = saldo < 0 ? 'text-danger' : 'text-success';

                                                                            return <strong className={saldoClass}>{saldoStr}</strong>;
                                                                        })()
                                                                    }
                                                                    </p>

                                                                </>


                                                                {(duty.logged_in_user === user?.id || duty.user_id === user?.id) && (
                                                                    <button type="button"
                                                                            className="btn btn-outline-success btn-sm ms-1  mb-2 mb-2 w-100"
                                                                            onClick={() => handleModalOpen(duty)}
                                                                    >
                                                                        <i className="fa fa-check"></i> Justificar
                                                                        Presença
                                                                    </button>
                                                                )}

                                                            </Col>

                                                        </Row>
                                                    </CardBody>
                                                </Card>


                                            </Col>
                                        ))
                                    ) : (
                                        <div className=" duty-card shadow-sm mb-3">
                                            <div className="alert alert-primary" role="alert">Nenhum plantão
                                                encontrado.

                                            </div>
                                        </div>
                                    )
                                )}
                            </Row>
                            <CustomPagination
                                className="mt-4"
                                pagination={pagination}
                                onChange={(page) => fetchAll(page, false, false)}
                            />

                        </div>


                        <DutyPresenceCheckModal
                            show={modalVisible}
                            handleClose={handleModalClose}
                            handleSubmit={fetchAll}
                            duty={selectedDuty}
                        />


                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PresenceCheckPage;
